<template>
  <v-list-item @click="router.push(item.route)">
    <v-row>
      <v-col class="d-flex justify-lg-space-between" cols="12">
        <v-list-item-title>
          {{ t(`kodeverkTable.title.${item.name}`) }}
        </v-list-item-title>
        <v-list-item-subtitle class="v-list-item__subtitle override_subtitle_flex pt-1">
          {{ getFormattedDate }}
        </v-list-item-subtitle>
      </v-col>
    </v-row>
  </v-list-item>
</template>

<script setup lang="ts">
import { formatDateForDisplay } from '@/utils/DateUtils'
import { MenuItem } from '@/types'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'

const router = useRouter()
const { t } = useI18n()

const props = defineProps<{ item: MenuItem }>()

const getFormattedDate = computed(() => {
  return props.item.distrDate ? formatDateForDisplay(props.item.distrDate) : ''
})
</script>
<style lang="scss" scoped>
.override_subtitle_flex {
  flex: none;
}
</style>
